import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="none">
        <path d="M10 14a4 4 0 100-8 4 4 0 000 8z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.359 13.979l-.094 1.45a.634.634 0 00.194.503 7.859 7.859 0 003.174 1.833.634.634 0 00.533-.084l1.21-.806h1.25l1.209.806a.634.634 0 00.532.084 7.859 7.859 0 003.175-1.833.633.633 0 00.193-.503l-.093-1.45.625-1.083 1.303-.644a.633.633 0 00.339-.42 7.86 7.86 0 000-3.665.634.634 0 00-.34-.42l-1.302-.643-.625-1.083.093-1.45a.633.633 0 00-.193-.503 7.86 7.86 0 00-3.175-1.833.634.634 0 00-.532.084l-1.21.806h-1.25l-1.209-.806a.634.634 0 00-.533-.084A7.859 7.859 0 004.46 4.068a.634.634 0 00-.194.503l.094 1.45-.625 1.083-1.303.644a.634.634 0 00-.339.419 7.859 7.859 0 000 3.666.634.634 0 00.339.419l1.303.644.625 1.083z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export default class IconSettings extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
